import { render, staticRenderFns } from "./StartStopTimer.vue?vue&type=template&id=1095b156&scoped=true&"
import script from "./StartStopTimer.vue?vue&type=script&lang=ts&"
export * from "./StartStopTimer.vue?vue&type=script&lang=ts&"
import style0 from "./StartStopTimer.vue?vue&type=style&index=0&id=1095b156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095b156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
